import { render, staticRenderFns } from "./AnswerCard.vue?vue&type=template&id=48689131&"
import script from "./AnswerCard.vue?vue&type=script&lang=js&"
export * from "./AnswerCard.vue?vue&type=script&lang=js&"
import style0 from "./AnswerCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports